






















import { Component, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import CommuneGuestTypeOption from '@/types/taxcard/CommuneGuestTypeOption';

@Component({
  components: { NewTranslation, Translation, FormField },
})
export default class RadioSelectField extends Vue {
  @Prop([String, Number])
  public value!: string | number;

  @Prop(String)
  public identifier!: string;

  @Prop(Function)
  public changeGuestType!: Function;

  @Prop(Function)
  public onInfoClick!: Function;

  @Prop(Array)
  public options!: CommuneGuestTypeOption[];
}
